import VueRouter from "vue-router";

import Index from "@views/index.vue";
import Login from "@views/login.vue";
import NoFound from "@views/404.vue";
import Menu from "@views/menu.vue";

// 懒加载
const My = () => import ("@views/my/my.vue");
const MySecond = () => import ("@views/my/mySecond.vue");
const Private = () => import ("@views/policy/private.vue");
const PaypalAdvance = () => import ("@views/payment/paypalAdvance.vue");
const Paypal = () => import ("@views/payment/paypal.vue");
const Stripe = () => import ("@views/payment/stripe.vue");
const VivaWallet = () => import ("@views/payment/vivaWallet.vue");
const Checkout = () => import ("@views/checkout.vue");

const Browse = ()=> import ("@views/browse/browse.vue");

const routes = [{
        path: "/",
        name: "Index",
        component: Index,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: "/index",
        name: "Index",
        component: Index,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: "/home",
        name: "Index",
        component: Index,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            noneHeader: false,
        },
    },
    {
        path: "/usercenter",
        name: "Usercenter",
        component: My,
        meta: {
            noneHeader: false,
            keepAlive: false,
        }
    },
    {
        path: "/my",
        name: "My",
        component: My,
        meta: {
            noneHeader: false,
            keepAlive: false,
        }
    },
    {
        path: "/editAddress",
        name: "EditAddress",
        component: () =>
            import ("@views/my/editAddress.vue"),
        meta: {
            noneHeader: false,
            keepAlive: false,
        },
    },
    {
        path: "/usercenter/myaccount",
        name: "myaccount",
        component: MySecond,
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/usercenter/address",
        name: "address",
        component: MySecond,
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/usercenter/orderhistory",
        name: "orderhistory",
        component: MySecond,
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/usercenter/points",
        name: "Points",
        component: () => import ("@/components/MyComps/Points.vue"),
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/usercenter/favourite",
        name: "Favourite",
        component: () => import ("@/components/MyComps/Favorite.vue"),
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/mySecond",
        name: "MySecond",
        component: MySecond,
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/browse",
        name: "Browse",
        component: Browse,
        meta: {
            keepAlive: true,
            noFixedHeader: true,
        }
    },
    {
        path: '/menu-*',
        name: 'Menu',
        component: Menu,
        meta: {
            keepAlive: true,
            noFixedHeader: true
        }
    },
    {
        path: "/checkout",
        name: "Checkout",
        // component: Checkout,
        component: Checkout,
        meta: {
            keepAlive: true,
            noFixedHeader: true,
        }
    },
    {
        path: "/paypalAdvance",
        name: "PaypalAdvance",
        component: PaypalAdvance,
        meta: {
            keepAlive: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/vivaWallet",
        name: "vivaWallet",
        component: VivaWallet,
        meta: {
            keepAlive: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/paypal",
        name: "paypal",
        component: Paypal,
        meta: {
            keepAlive: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/stripe",
        name: "Stripe",
        component: Stripe,
        meta: {
            keepAlive: false,
            noFixedHeader: true,
        },
    },
    {
        path: "/about",
        name: "About",
        component: () =>
            import ("@/views/about/index.vue"),
    },
    {
        path: "/cuisine",
        name: "Category",
        component: () =>
            import ("@/views/about/index.vue"),
    },
    {
        path: "/contact",
        name: "Contact",
        component: () =>
            import ("@/views/contact/index.vue")
    },
    {
        path: "/notFound",
        name: "404",
        component: NoFound,
    },
    {
        path: "/404",
        name: "404",
        component: NoFound,
    },
    {
        path: '*',
        name: 'Menu',
        component: Menu,
        meta: {
            keepAlive: true,
            noFixedHeader: true
        }
    },
    {
        path: "/Privacy-Policy",
        name: "Private",
        component: Private,
    },
    {
        path: "/privacy-policy",
        name: "Private",
        component: Private,
    },
    {
        path: '/orderSuccess',
        name: "orderSuccess",
        component: () =>
            import ("@/views/payment/orderSuccess.vue"),
    },
    {
        path: '/appPayCenter',
        name: "appPayCenter",
        component: () =>
            import ("@/views/payment/appPayCenter.vue"),
    },
    {
        path: '/payFail',
        name: "payFail",
        component: () =>
            import ("@/views/payment/payFail.vue"),
    },
    {
        path: "/privatePage",
        name: "Private",
        component: Private,
    },
    {
        path: "/faqs",
        name: "Faqs",
        component: () =>
            import ("@/views/policy/faqs.vue")
    },
    {
        path: "/termsConditions",
        name: "TermsAndConditions",
        component: () =>
            import ("@/views/policy/termsAndConditions.vue"),
    },
    {
        path: "/refundAndCancellations",
        name: "RefundAndCancellations",
        component: () =>
            import ("@/views/policy/refundAndCancellations.vue"),
    },
    {
        path: "/cookiePolicy",
        name: "CookiePolicy",
        component: () =>
            import ("@/views/policy/cookiePolicy.vue"),
    },
    {
        path: "/reviews",
        name: "Reviews",
        component: () =>
            import ("@/views/review.vue"),
    },
    {
        path: "/developer",
        name: "Developer",
        component: () => import ("@/views/develop/index.vue"),
        meta: {
            noneHeader: false,
            noFixedHeader: true,
        },
    },
];

function fixSticky() {
    // 单独给 html body 设置css 属性解决 sticky 问题
    document.querySelector('html').style.overflowX = 'unset';
    document.querySelector('body').style.overflowX = 'unset';
}

function fixOverfowX() {
    // 单独给 html body 设置css 属性解决 sticky 问题
    document.querySelector('html').style.overflowX = 'hidden';
    document.querySelector('body').style.overflowX = 'hidden';
}

export default new VueRouter({
    mode: "history",
    base: "",
    routes, // (缩写) 相当于 routes: routes
    // eslint-disable-next-line
    scrollBehavior(to, from, savedPosition) {
        fixOverfowX();
        if (to.path.includes("menu-") || to.path.includes("browse") || to.path.includes("mySecond")) {
            fixSticky(); // 部分路由横向滑动开放
        }

        // 处理滚动距离
        if (to.path.includes("menu-") || to.path.includes("checkout") || to.path.includes("orderSuccess")) {
            // document.body.scrollTop = document.documentElement.scrollTop = 100;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        } else if (to.path.includes("login")) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        } else {
            // 始终滚动到顶部
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
        return { top: 0 };
    }
});